import { BASE } from '../components/Box/constants';

const base = (multiple: number, addUnit = 'px'): number | string => {
  const value = BASE * multiple;
  if (addUnit) return `${value}${addUnit}`;
  return value;
};

export default base;
